import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';

import { Typography, IconButton, Box } from '@mui/material';
import { NoteDrawer } from 'components/Notes/components';
import InfoIcon from '@mui/icons-material/InfoOutlined';

const DrawerInfo = ({
  title,
  titleVariant,
  subtitle,
  content,
  icon,
  drawerTitle,
  titleDesc,
}) => {
  const { t } = useTranslation();
  const [showDrawer, setShowDrawer] = useState(false);

  return (
    <>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        {title && (
          <Typography variant={titleVariant ?? 'h4'}>{t(title)}</Typography>
        )}
        {icon && (
          <IconButton
            style={{ padding: 0, marginLeft: 8 }}
            onClick={setShowDrawer}>
            <InfoIcon style={{ width: '22px' }} />
          </IconButton>
        )}
      </Box>
      {subtitle && (
        <Typography
          variant="subtitle2"
          style={{ margin: '10px 0px', fontSize: '12px' }}>
          {t(subtitle)}
        </Typography>
      )}
      <NoteDrawer
        setShowDrawer={setShowDrawer}
        showDrawer={showDrawer}
        title={t(drawerTitle)}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: 20,
          }}>
          {titleDesc && <Typography variant="h5">{t(titleDesc)}</Typography>}
          {content &&
            map(content, (section) => (
              <Box style={{ marginBottom: '10px' }}>
                {section.title && (
                  <Typography style={{ fontWeight: 'bold' }}>
                    {t(section.title)}
                  </Typography>
                )}
                <Typography style={{ margin: '8px 0' }}>
                  {t(section.description)}
                </Typography>
              </Box>
            ))}
        </Box>
      </NoteDrawer>
    </>
  );
};

export default DrawerInfo;
